import { render, staticRenderFns } from "./_base-empty-list.vue?vue&type=template&id=244e44aa&scoped=true"
import script from "./_base-empty-list.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-empty-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-empty-list.vue?vue&type=style&index=0&id=244e44aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e44aa",
  null
  
)

export default component.exports